document.addEventListener('DOMContentLoaded', function () {
  const parentCheckboxes = document.querySelectorAll(
    '.form-section > label > input[type="checkbox"][name^="properties["]'
  );

  parentCheckboxes.forEach(parent => {
    const label = parent.closest('label');
    if (!label) return;

    const subcategory = label.nextElementSibling;
    if (!subcategory || !subcategory.classList.contains('subcategory')) return;

    const childCheckboxes = subcategory.querySelectorAll('input[type="checkbox"][name^="properties["]');

    parent.addEventListener('change', () => {
      const isChecked = parent.checked;
      childCheckboxes.forEach(cb => {
        cb.checked = isChecked;
        cb.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    childCheckboxes.forEach(cb => {
      cb.addEventListener('change', () => {
        const allChecked = Array.from(childCheckboxes).every(c => c.checked);
        parent.checked = allChecked;
      });
    });
  });

   const toggleInputs = document.querySelectorAll('.custom-section-toggle-btn input[type="checkbox"]');

  toggleInputs.forEach(input => {
    input.addEventListener('change', function () {
      const parent = input.closest('.custom-section-toggle-btn');
      const targetKey = parent.getAttribute('toggle-data');
      const targetSection = document.querySelector(`.checkbox-wrapper[data-head="${targetKey}"]`);

      if (targetSection) {
        if (input.checked) {
          // Disable labels except those inside .custom-section-toggle-btn
          targetSection.querySelectorAll('label').forEach(label => {
            
            // Skip if label is inside toggle button container
            if (label.closest('.custom-section-toggle-btn')) return;

            // Skip if already has class is-disabled
            if (label.classList.contains('is-disabled')) return;

            label.classList.add('is-disabled');
          });

        } else {

          // Remove disabled class but only from labels whose input is not disabled
          targetSection.querySelectorAll('label').forEach(label => {

            const inputInside = label.querySelector('input');

            // If input has disabled attribute, do NOT remove class
            if (inputInside && inputInside.hasAttribute('disabled')) {
              return;
            }

            // Safe to remove class
            label.classList.remove('is-disabled');
          });
        }
      } else {
        console.warn('No matching section found for', targetKey);
      }
    });
  });

// const parentLabels = document.querySelectorAll('.custom-parent-head label');
// const nestedWrappers = document.querySelectorAll('.nested-checkbox-wrapper');

// parentLabels.forEach(label => {
//   const input = label.querySelector('input');
//   if (!input) return;

//   input.addEventListener('change', () => {
//     const parentValue = label.getAttribute('parent-title');

//     nestedWrappers.forEach(wrapper => {
//       const childLabel = wrapper.querySelector('label[child-toggle]');
//       const childValue = childLabel ? childLabel.getAttribute('child-toggle') : null;

//       if (parentValue === childValue) {
//         if (input.checked) {
//           wrapper.classList.add('visible');
//           wrapper.classList.remove('hidden');

//           // // 🟢 Auto open / click child label only once
//           // if (childLabel && !childLabel.dataset.clicked) {
//           //   childLabel.click();
//           //   childLabel.dataset.clicked = 'true';
//           // }

//         } else {
//           wrapper.classList.remove('visible');
//           wrapper.classList.add('hidden');

//           // ❌ Uncheck all child checkboxes when parent unchecked
//           const childInputs = wrapper.querySelectorAll('input[type="checkbox"], input[type="radio"]');
//           childInputs.forEach(childInput => {
//             if (childInput.checked) {
//               childInput.checked = false;
//               // Trigger change event to remove line item
//               childInput.dispatchEvent(new Event('change', { bubbles: true }));
//             }
//           });

//           // // Reset click flag for next time
//           // if (childLabel) {
//           //   delete childLabel.dataset.clicked;
//           // }
//         }
//       }
//     });
//   });
// });


});
  
